import { render, staticRenderFns } from "./JobInfoAdvertModal.vue?vue&type=template&id=dd2d4ff8&scoped=true"
import script from "./JobInfoAdvertModal.vue?vue&type=script&lang=js"
export * from "./JobInfoAdvertModal.vue?vue&type=script&lang=js"
import style0 from "./JobInfoAdvertModal.vue?vue&type=style&index=0&id=dd2d4ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2d4ff8",
  null
  
)

export default component.exports